import { Observable } from "rxjs/Observable"

import { getAuthHeader } from "./utils/network-config"

export const getDashboardInfo = token =>
    Observable.ajax.getJSON(
        `${process.env.REACT_APP_DASHBOARD_URI}/info`,
        getAuthHeader(token)
    )
